import { useContext, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  faBell,
  faCalendar,
  faDownload,
  faEllipsisVertical,
  faGear,
  faPersonWalkingArrowRight,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { RequirePermissions, Permissions } from '@/core/permissions/export';
import { AppContext, Context } from '@/core/app-context/export';
import { Credentials, authService } from '@/core/auth/export';
import { useOpenWidget } from '@/core/widget-navigation/export';

import styles from '@/core/menu/index.module.scss';
import { installService } from '@/shared/install/export';

export default function Menu({ padding = true }: { padding?: boolean }) {
  const [credentials, setCredentials] = useState<Credentials>();
  const openWidget = useOpenWidget();

  useEffect(() => {
    authService.onTokenAvailable().then(value => {
      setCredentials(authService.getCredentials);
    });
  }, []);

  const logout = () => {
    authService.logout().then(() => {
      window.location.reload();
    });
  };

  const { showMenu } = useContext<AppContext>(Context);

  if (!showMenu) return <></>;

  return (
    <>
      <div className={'' + (padding && 'ms-1')} role="group" aria-label="Basic example">
        <Dropdown className={'mb-0 pb-0'}>
          <Dropdown.Toggle
            type={'button'}
            variant="outline-secondary "
            id="dropdown-basic"
            size="sm"
            className={`${styles.settingsDropdown} btn-menu mb-0`}
          >
            <FontAwesomeIcon icon={faEllipsisVertical} />
          </Dropdown.Toggle>

          <Dropdown.Menu className={'border-warning'}>
            <div className={'dropdown-item disabled small'}>
              Logged in as <strong>{credentials?.body.sub}</strong>
            </div>
            <Dropdown.Item href={'/dashboard'}>
              <FontAwesomeIcon className={'text-secondary'} icon={faUpRightAndDownLeftFromCenter} />{' '}
              Dashboard
            </Dropdown.Item>
            <Dropdown.Divider className={'border-secondary'} />
            <Link to={'/'} className={'dropdown-item'}>
              <FontAwesomeIcon className={'text-secondary'} icon={faCalendar} /> Data Calendar
            </Link>

            <Dropdown.Divider className={'border-secondary'} />
            <Dropdown.Item onClick={() => openWidget('settings')}>
              <FontAwesomeIcon className={'text-secondary'} icon={faGear} />️ Settings
            </Dropdown.Item>

            <RequirePermissions>
              <Dropdown.Item onClick={() => openWidget('settings', 'notifications')}>
                <FontAwesomeIcon className={'text-secondary'} icon={faBell} /> Notifications
              </Dropdown.Item>
            </RequirePermissions>

            <RequirePermissions allow={Permissions.BETA_ACCESS}>
              {installService.canInstall() && (
                <Dropdown.Item onClick={() => installService.install()}>
                  <FontAwesomeIcon className={'text-secondary'} icon={faDownload} />️ Install
                </Dropdown.Item>
              )}
            </RequirePermissions>

            <Dropdown.Divider className={'border-secondary'} />
            <Dropdown.Item onClick={() => logout()} target={'_blank'}>
              <FontAwesomeIcon className={'text-secondary'} icon={faPersonWalkingArrowRight} />{' '}
              Logout{' '}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
}
